import React from 'react';
import './style.scss';

export const FullScreenOverlay = () => <div className="app-fullscreen-overlay"/>;